import type { ButtonHTMLAttributes } from 'react';

import {
  ArrowLeftIcon,
  ArrowRightIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  classNames,
} from '@movingimage-evp/mi-ui-component-library';
import { useTranslation } from 'react-i18next';

/* eslint css-modules/no-unused-class: [2, { markAsUsed: ['presentationPreview', 'slidesList'] }] */
import styles from './presentation-preview.module.css';

type PresentationPreviewButtonsProps = {
  active?: boolean;
  image?: string;
  label?: string;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export function SlideButton({ active, image, label, ...props }: PresentationPreviewButtonsProps) {
  return (
    <button
      data-testid="presentation-preview-slide-button"
      type="button"
      role="tab"
      className={classNames(styles.slideButton, active && styles.active)}
      {...props}
    >
      <img src={image} alt={label ?? ''} />
      <span>{label}</span>
    </button>
  );
}

export function PrevSlideButton(props: ButtonHTMLAttributes<HTMLButtonElement>) {
  const { t } = useTranslation();

  return (
    <button
      data-testid="presentation-preview-previous-slide-button"
      type="button"
      className={styles.slideControlButton}
      {...props}
    >
      <ArrowLeftIcon />
      {t('presentationPreview.button.prevSlide.label')}
    </button>
  );
}

export function NextSlideButton(props: ButtonHTMLAttributes<HTMLButtonElement>) {
  const { t } = useTranslation();

  return (
    <button
      data-testid="presentation-preview-next-slide-button"
      type="button"
      className={styles.slideControlButton}
      {...props}
    >
      {t('presentationPreview.button.nextSlide.label')}
      <ArrowRightIcon />
    </button>
  );
}

export function ScrollLeftButton(props: ButtonHTMLAttributes<HTMLButtonElement>) {
  const { t } = useTranslation();

  return (
    <button
      data-testid="presentation-preview-scroll-left-button"
      type="button"
      aria-label={t('presentationPreview.button.scrollLeft.label')}
      className={styles.scrollButton}
      {...props}
    >
      <ChevronLeftIcon />
    </button>
  );
}

export function ScrollRightButton(props: ButtonHTMLAttributes<HTMLButtonElement>) {
  const { t } = useTranslation();

  return (
    <button
      data-testid="presentation-preview-scroll-right-button"
      type="button"
      aria-label={t('presentationPreview.button.scrollRight.label')}
      className={styles.scrollButton}
      {...props}
    >
      <ChevronRightIcon />
    </button>
  );
}
